import { useContext } from "react"
import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import AuthContext from "../context/AuthProvider"
import { useLayoutMode } from "../layout/LayoutModeContext"
import DesktopShell from "../desktop/DesktopShell"

// import Announcement from "./Announcement"

const Layout = () => {
  const { auth } = useContext(AuthContext)
  const { isDesktop } = useLayoutMode()

  if (isDesktop && auth?.user) {
    return <DesktopShell />
  }

  return (<>

    <Header />
    {/* <Announcement /> */}
    <main className="App">

      <Outlet />
    </main>
    <Footer />
  </>

  )
}

export default Layout
